"use client";
// import React from "react";
// import { Footer } from "@yardstick/shared-ui";

// const FooterComponent = () => {
//   return <Footer footerBaseUrl={process.env.NEXT_PUBLIC_NAVBAR_URL} />;
// };

// export default FooterComponent;

import Image from "next/image";
import Link from "next/link";
import logo from "../../public/images/logo/yardsticklive_logo.png";
import FooterLinks from "@/components/Footer/FooterLinks";
import { SVG_COLOR } from "@/utils/Const";
import { FaRegCopyright } from "react-icons/fa6";

const Footer = () => {
  const SvgColor = SVG_COLOR;
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer
        className="wow fadeInUp relative z-10 border-t border-gray-300 bg-purple-50 pt-16 dark:border-gray-800 dark:bg-[#030712] md:pt-20 lg:pt-24"
        data-wow-delay=".1s"
      >
        <div className="container">
          <div className={"grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4"}>
            <div className="w-full px-4">
              <div className="mb-12 max-w-[360px] lg:mb-16">
                <Link href="/" className="mb-8 inline-block w-full">
                  <div className={"flex items-center gap-2"}>
                    <Image
                      loading="eager"
                      src={logo}
                      alt="logo"
                      className="block"
                      width={30}
                      height={30}
                    />
                    <div className={"text-xl dark:text-white"}>Yardstick</div>
                  </div>
                </Link>
                <p className="mb-9 text-base leading-relaxed text-body-color dark:text-body-color-dark">
                  Fuel your growth with our expertise in Shopify apps, Meta,
                  WhatsApp marketing, and AI services. Yardstick – where
                  innovation meets results.
                </p>
                <div className="flex items-center">
                  <a
                    href="https://twitter.com/yardstick_ai"
                    aria-label="social-link"
                    className="mr-6 text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
                  >
                    <svg
                      width="19"
                      height="14"
                      viewBox="0 0 19 14"
                      className="fill-current"
                    >
                      <path d="M16.3024 2.26027L17.375 1.0274C17.6855 0.693493 17.7702 0.436644 17.7984 0.308219C16.9516 0.770548 16.1613 0.924658 15.6532 0.924658H15.4556L15.3427 0.821918C14.6653 0.282534 13.8185 0 12.9153 0C10.9395 0 9.3871 1.48973 9.3871 3.21062C9.3871 3.31336 9.3871 3.46747 9.41532 3.57021L9.5 4.0839L8.90726 4.05822C5.29435 3.95548 2.33065 1.13014 1.85081 0.642123C1.06048 1.92637 1.5121 3.15925 1.99194 3.92979L2.95161 5.36815L1.42742 4.5976C1.45565 5.67637 1.90726 6.52397 2.78226 7.14041L3.54435 7.65411L2.78226 7.93665C3.2621 9.24658 4.33468 9.78596 5.125 9.99144L6.16935 10.2483L5.18145 10.8647C3.60081 11.8921 1.625 11.8151 0.75 11.738C2.52823 12.8682 4.64516 13.125 6.1129 13.125C7.21371 13.125 8.03226 13.0223 8.22984 12.9452C16.1331 11.25 16.5 4.82877 16.5 3.54452V3.36473L16.6694 3.26199C17.629 2.44007 18.0242 2.00342 18.25 1.74658C18.1653 1.77226 18.0524 1.82363 17.9395 1.84932L16.3024 2.26027Z" />
                    </svg>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/yardsticklive/"
                    aria-label="social-link"
                    className="text-body-color duration-300 hover:text-primary dark:text-body-color-dark dark:hover:text-primary"
                  >
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      className="fill-current"
                    >
                      <path d="M15.2196 0H1.99991C1.37516 0 0.875366 0.497491 0.875366 1.11936V14.3029C0.875366 14.8999 1.37516 15.4222 1.99991 15.4222H15.1696C15.7943 15.4222 16.2941 14.9247 16.2941 14.3029V1.09448C16.3441 0.497491 15.8443 0 15.2196 0ZM5.44852 13.1089H3.17444V5.7709H5.44852V13.1089ZM4.29899 4.75104C3.54929 4.75104 2.97452 4.15405 2.97452 3.43269C2.97452 2.71133 3.57428 2.11434 4.29899 2.11434C5.02369 2.11434 5.62345 2.71133 5.62345 3.43269C5.62345 4.15405 5.07367 4.75104 4.29899 4.75104ZM14.07 13.1089H11.796V9.55183C11.796 8.7061 11.771 7.58674 10.5964 7.58674C9.39693 7.58674 9.222 8.53198 9.222 9.47721V13.1089H6.94792V5.7709H9.17202V6.79076H9.19701C9.52188 6.19377 10.2466 5.59678 11.3711 5.59678C13.6952 5.59678 14.12 7.08925 14.12 9.12897V13.1089H14.07Z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <FooterLinks
              heading={"Link"}
              subHeading={[
                { title: "Home", link: "/#home" },
                { title: "About", link: "/#about" },
                { title: "Projects", link: "/#projects" },
                { title: "Blog", link: "/blog" },
                { title: "Contact US", link: "/#contact" },
              ]}
            />
            <FooterLinks
              heading={"Legal"}
              subHeading={[
                { title: "Privacy Policy", link: "/privacy-policy" },
                { title: "Terms & Conditions", link: "/terms-and-conditions" },
                { title: "Refund Policy", link: "/refund-policy" },
              ]}
            />
            <FooterLinks
              heading={"Our Expertise"}
              subHeading={[
                { title: "AI Development Services", link: "/ai-services" },
                {
                  title: "Facebook API",
                  link: "/facebook-api",
                },
                {
                  title: "Shopify App Development",
                  link: "/shopify-app-development",
                },
                {
                  title: "WhatsApp Business API",
                  link: "/whatsapp-business-api",
                },
              ]}
            />
            {/*<FooterLinks heading={'AI & Engineering'}*/}
            {/*             subHeading={*/}
            {/*               [*/}
            {/*                 {title: 'AI-Driven Engineering Innovations', link: '/'},*/}
            {/*                 {title: 'Ethical Considerations in AI Engineering', link: '/'},*/}
            {/*                 {title: 'Optimizing Operations: AI Applications in Engineering Processes', link: '/'},*/}
            {/*                 {title: 'Future-Proofing Engineering: The Role of AI', link: '/'},*/}
            {/*                 {title: 'Human-Machine Collaboration in Engineering with AI', link: '/'},*/}
            {/*               ]*/}
            {/*             }/>*/}
            {/*<FooterLinks heading={'Machine Learning'}*/}
            {/*             subHeading={*/}
            {/*               [*/}
            {/*                 {title: 'AI in Test Automation: Revolutionizing Software Testing', link: '/'},*/}
            {/*                 {title: 'Machine Learning for Test Case Optimization', link: '/'},*/}
            {/*                 {title: 'AI-Driven Predictive Testing: Anticipating Software Issues', link: '/'},*/}
            {/*                 {title: 'Ethical Considerations in AI-Based Testing', link: '/'},*/}
            {/*                 {title: 'Automating Test Data Generation with AI', link: '/'},*/}
            {/*                 {title: 'AI-Powered Performance Testing: Ensuring Scalability and Reliability', link: '/'},*/}
            {/*               ]*/}
            {/*             }/>*/}

            {/*<FooterLinks heading={'AI & Engineering'}*/}
            {/*             subHeading={*/}
            {/*               [*/}
            {/*                 {title: 'AI-Driven Engineering Innovations', link: '/'},*/}
            {/*                 {title: 'Ethical Considerations in AI Engineering', link: '/'},*/}
            {/*                 {title: 'Optimizing Operations: AI Applications in Engineering Processes', link: '/'},*/}
            {/*                 {title: 'Future-Proofing Engineering: The Role of AI', link: '/'},*/}
            {/*                 {title: 'Human-Machine Collaboration in Engineering with AI', link: '/'},*/}
            {/*               ]*/}
            {/*             }/>*/}
            {/*<FooterLinks heading={'Machine Learning'}*/}
            {/*             subHeading={*/}
            {/*               [*/}
            {/*                 {title: 'AI in Test Automation: Revolutionizing Software Testing', link: '/'},*/}
            {/*                 {title: 'Machine Learning for Test Case Optimization', link: '/'},*/}
            {/*                 {title: 'AI-Driven Predictive Testing: Anticipating Software Issues', link: '/'},*/}
            {/*                 {title: 'Ethical Considerations in AI-Based Testing', link: '/'},*/}
            {/*                 {title: 'Automating Test Data Generation with AI', link: '/'},*/}
            {/*                 {title: 'AI-Powered Performance Testing: Ensuring Scalability and Reliability', link: '/'},*/}
            {/*               ]*/}
            {/*             }/>*/}
            {/*<FooterLinks heading={'Machine Learning'}*/}
            {/*             subHeading={*/}
            {/*               [*/}
            {/*                 {title: 'AI in Test Automation: Revolutionizing Software Testing', link: '/'},*/}
            {/*                 {title: 'Machine Learning for Test Case Optimization', link: '/'},*/}
            {/*                 {title: 'AI-Driven Predictive Testing: Anticipating Software Issues', link: '/'},*/}
            {/*                 {title: 'Ethical Considerations in AI-Based Testing', link: '/'},*/}
            {/*                 {title: 'Automating Test Data Generation with AI', link: '/'},*/}
            {/*                 {title: 'AI-Powered Performance Testing: Ensuring Scalability and Reliability', link: '/'},*/}
            {/*               ]*/}
            {/*             }/>*/}
          </div>

          <div className="h-px w-full bg-gradient-to-r from-transparent via-[#D2D8E183] to-transparent dark:via-[#959CB183]"></div>
          <div className="py-8">
            <p className="flex items-center justify-center gap-2 text-center text-base text-body-color dark:text-white">
              Copyright <FaRegCopyright />  {currentYear} | Yardstick | All rights
              reserved.
            </p>
          </div>
        </div>
        <div className="absolute bottom-24 left-0 z-[-1]">
          <svg
            width="79"
            height="94"
            viewBox="0 0 79 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="-41"
              y="26.9426"
              width="66.6675"
              height="66.6675"
              transform="rotate(-22.9007 -41 26.9426)"
              fill="url(#paint0_linear_94:889)"
            />
            <rect
              x="-41"
              y="26.9426"
              width="66.6675"
              height="66.6675"
              transform="rotate(-22.9007 -41 26.9426)"
              stroke="url(#paint1_linear_94:889)"
              strokeWidth="0.7"
            />
            <path
              opacity="0.4"
              d="M50.5215 7.42229L20.325 1.14771L46.2077 62.3249L77.1885 68.2073L50.5215 7.42229Z"
              fill="url(#paint2_linear_94:889)"
            />
            <path
              d="M50.5215 7.42229L20.325 1.14771L46.2077 62.3249L76.7963 68.2073L50.5215 7.42229Z"
              stroke="url(#paint3_linear_94:889)"
              strokeWidth="0.7"
            />
            <path
              opacity="0.4"
              d="M17.9721 93.3057L-14.9695 88.2076L46.2077 62.325L77.1885 68.2074L17.9721 93.3057Z"
              fill="url(#paint4_linear_94:889)"
            />
            <path
              d="M17.972 93.3057L-14.1852 88.2076L46.2077 62.325L77.1884 68.2074L17.972 93.3057Z"
              stroke="url(#paint5_linear_94:889)"
              strokeWidth="0.8"
            />
            <defs>
              <linearGradient
                id="paint0_linear_94:889"
                x1="-41"
                y1="21.8445"
                x2="36.9671"
                y2="59.8878"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={SvgColor} stopOpacity="0.82" />
                <stop offset="1" stopColor={SvgColor} stopOpacity="0.3" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_94:889"
                x1="25.6675"
                y1="95.9631"
                x2="-42.9608"
                y2="20.668"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={SvgColor} stopOpacity="0.4" />
                <stop offset="1" stopColor={SvgColor} stopOpacity="0.91" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_94:889"
                x1="20.325"
                y1="-3.98039"
                x2="90.6248"
                y2="25.1062"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={SvgColor} stopOpacity="0.82" />
                <stop offset="1" stopColor={SvgColor} stopOpacity="0.3" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_94:889"
                x1="18.3642"
                y1="-1.59742"
                x2="113.9"
                y2="80.6826"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={SvgColor} stopOpacity="0.4" />
                <stop offset="1" stopColor={SvgColor} stopOpacity="0.91" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_94:889"
                x1="61.1098"
                y1="62.3249"
                x2="-8.82468"
                y2="58.2156"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={SvgColor} stopOpacity="0.82" />
                <stop offset="1" stopColor={SvgColor} stopOpacity="0.3" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_94:889"
                x1="65.4236"
                y1="65.0701"
                x2="24.0178"
                y2="41.6598"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor={SvgColor} stopOpacity="0.4" />
                <stop offset="1" stopColor={SvgColor} stopOpacity="0.91" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </footer>
    </>
  );
};

export default Footer;
